import * as Icons from '@heroicons/vue/24/outline/index' // Hero icon v2

type IconKeys = keyof typeof Icons
export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  Object.keys(Icons).forEach((icon: string) => {
    nuxtApp.vueApp.component('Hi' + icon, Icons[icon as IconKeys])
  })
})
